import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER, PRICE_EVOL_LEGENT} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-widget-evol-prix-immo',
    templateUrl: './evol-prix-immo.component.html',
    styleUrls: ['./evol-prix-immo.component.scss']
})

export class EvolPrixImmoComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();
    user: User = Object.assign({}, EMPTY_USER);

    echartsIntance = null;

    options;
    data = {
        series: [],
    };

    constructor(
        public authenticationService: AuthenticationService,
        public deviceService: DeviceDetectorService) {
    }

    ngOnInit() {
        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
        this.user = this.authenticationService.currentUser;
    }

    setData() {

        if (this.favorite.ad_city.city_code === '') {
            return;
        }

        const dataAdep = [];
        const dataMdep = [];
        const dataAville = [];
        const dataMville = [];

        this.options = {
            tooltip: {
                trigger: 'axis',
                /*  formatter: function (params) {
                      params = params[0];
                      var date = new Date(params.name);
                      return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' : ' + params.value[1];
                  },*/
                axisPointer: {
                    animation: false
                },
                formatter: params => {
                    let lib = params[0].name + '<br/>';
                    params.forEach(d => {
                        lib += '<span style="font-size:24px; color: ' + d.color + '">• </span>' + d.seriesName + ' : ' + Math.round(d.data).toLocaleString('fr-FR') + ' €/m²<br/>';
                    });
                    return lib;
                }
            },
            legend: {
                orient: 'vertical',
                right: '40px',
                bottom: '70px',
                align: 'right',
                selected: {},
            },
            grid: [{
                left: '20px',
                right: '10px',
                top: '20px',
                bottom: '20px',
                containLabel: true
            }],
            xAxis: {
                data: [],
                axisLabel: {interval: 0, rotate: 45},
                // axisLabel: {
                //     formatter: (function(value){
                //         var date = new Date(value);
                //         return  (date.getMonth() + 1) + '/' + date.getFullYear();
                //     })
                // },
                axisTick: {
                    alignWithLabel: true,
                },
            },
            yAxis: {
                type: 'value',
                //  axisLabel: 'Prix en €/m²',
                label: {
                    formatter: '{b} <br/>{a} : {c} €/m²',
                },
                min: 10000,
                axisLabel: {
                    formatter: '{value} €/m²'
                }
                // formatter: params => {
                //      return params[0].name + ' : ' + parseFloat(params[0].data).toLocaleString('fr-FR', {style: 'currency', currency: 'EUR'}) + '/m²<br/>';
                //   },
            },
            color: ['#2980B9', '#8E44AD', '#C0392B', '#E67E22'],

            series: []
        };


        if (this.deviceService.isMobile()) {
            this.options.grid[0].top = '105px';
            this.options.grid[0].left = '0px';
            this.options.grid[0].bottom = '0px';
            this.options.legend = {
                orient: 'horizontal',
                right: 'auto',
                align: 'auto',
            };
            this.options.xAxis.axisLabel.interval = 1;
        }

        this.data = {
            series: [],
        };

        this.options.xAxis.data = PRICE_EVOL_LEGENT;
        this.options.xAxis.data.forEach(keys => {

            if (this.favorite.ad_city.prix_departement.A != null && this.favorite.ad_city.prix_departement.A[keys] !== undefined) {
                dataAdep.push(this.favorite.ad_city.prix_departement.A[keys].pM);
                if (this.options.yAxis.min > (this.favorite.ad_city.prix_departement.A[keys].pM * 0.8)) {
                    this.options.yAxis.min = Math.round(this.favorite.ad_city.prix_departement.A[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataAdep.push('');
            }

            if (this.favorite.ad_city.prix_departement.M != null && this.favorite.ad_city.prix_departement.M[keys] !== undefined) {
                dataMdep.push(this.favorite.ad_city.prix_departement.M[keys].pM);
                if (this.options.yAxis.min > (this.favorite.ad_city.prix_departement.M[keys].pM * 0.8)) {
                    this.options.yAxis.min = Math.round(this.favorite.ad_city.prix_departement.M[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataMdep.push('');
            }

            if (this.favorite.ad_city.prix_ville.A != null && this.favorite.ad_city.prix_ville.A[keys] !== undefined) {
                dataAville.push(this.favorite.ad_city.prix_ville.A[keys].pM);
                if (this.options.yAxis.min > (this.favorite.ad_city.prix_ville.A[keys].pM * 0.8)) {
                    this.options.yAxis.min = Math.round(this.favorite.ad_city.prix_ville.A[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataAville.push('');
            }

            if (this.favorite.ad_city.prix_ville.M != null && this.favorite.ad_city.prix_ville.M[keys] !== undefined) {
                dataMville.push(this.favorite.ad_city.prix_ville.M[keys].pM);

                if (this.options.yAxis.min > (this.favorite.ad_city.prix_ville.M[keys].pM * 0.8)) {
                    this.options.yAxis.min = Math.round(this.favorite.ad_city.prix_ville.M[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataMville.push('');
            }
        });

        this.data.series.push({
            name: this.favorite.ad_city.departement + ' : Appartement',
            type: 'line',
            data: dataAdep
        });

        this.data.series.push({
            name: this.favorite.ad_city.departement + ' : Maison',
            type: 'line',
            data: dataMdep
        });

        this.data.series.push({
            name: this.favorite.ad_city.name + ' : Appartement',
            type: 'line',
            data: dataAville
        });

        this.data.series.push({
            name: this.favorite.ad_city.name + ' : Maison',
            type: 'line',
            data: dataMville
        });

        this.options.legend.selected = {
            [this.favorite.ad_city.departement + ' : Appartement']: dataAville.filter(Boolean).length < 1,
            [this.favorite.ad_city.departement + ' : Maison']: dataMville.filter(Boolean).length < 1,
            [this.favorite.ad_city.name + ' : Appartement']: dataAville.filter(Boolean).length >= 1,
            [this.favorite.ad_city.name + ' : Maison']: dataMville.filter(Boolean).length >= 1,
        };

        if (this.echartsIntance) {
            this.echartsIntance.setOption(this.options);
        }
    }

    onChartInit(ec) {
        this.echartsIntance = ec;
    }
}
